<template>
  <!-- Modal terms -->
  <div
    class="modal fade show"
    id="payment-verify-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="PaymentVerifyModal"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="PaymentVerifyModal">{{ $t('Mükellef Kuralları') }}</h4>
          <button type="button" id="modal-close" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <p v-html="$t('Mükellef Kuralları text1')"></p>
          <p v-html="$t('Mükellef Kuralları text2', { link: this.privacyLink })"></p>
        </div>
        <div class="modal-footer">
          <div class="form-group">
            <div class="text-right">
              <button class="btn btn-danger mr-2" type="button" data-dismiss="modal" aria-hidden="true">
                {{ $t('Kapat') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'PaymentVerifyModal',
  data() {
    return {};
  },
};
</script>

<style scoped>
button {
  font-size: 0.875rem;
}
</style>
